import React, { useState } from 'react'
import { useStore } from 'hooks/useStore'
import { useLocales } from 'hooks/useLocales'
import styles from './pastVotesList.m.scss'
import { Vote } from 'types/config'
import smoothscroll from 'smoothscroll-polyfill'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'

smoothscroll.polyfill()

export const PastVotesList = ({
  votes,
  format
}: {
  votes: Array<Vote>
  format: string
}) => {
  const { locale, messages } = useLocales()
  const [yearsMax, setYearsMax] = useState(2)
  const { setUrlParams } = useStore()
  const years = new Set(votes.map(v => v.formatedDate.getFullYear()))
  const yearGroups = Array.from(years).map(y => ({
    year: y,
    votes: votes.filter(v => v.formatedDate.getFullYear() === y)
  }))

  return (
    <div className='section'>
      <h4 className='section-title'>{messages.pastVotesTitle}</h4>
      <div className='ui very relaxed list'>
        {yearGroups.slice(0, yearsMax).map(yearGroup => (
          <div
            className={`item ${styles.yearBlock}`}
            key={`year-group-${yearGroup.year}`}
          >
            <h6 className='sub section-title'>
              {messages.year} {yearGroup.year}
            </h6>
            <div
              className={`ui middle aligned divided list ${styles.pastVoteItemsList}`}
            >
              {yearGroup.votes.map(vote => {
                const voteTitle = vote[`votes_${locale}`]

                return (
                  <div
                    className={`item ${styles.item}`}
                    key={`vote-year-${vote.date}`}
                    onClick={() => {
                      const searchBox = document.getElementById('search-box')
                      // Do the people actually use this menu?
                      window.dataLayer = window.dataLayer || []
                      window.dataLayer.push({
                        event: 'Interactions',
                        event_action: 'click',
                        event_label: `nav:${vote.date}`
                      })
                      setUrlParams({
                        date: vote.date
                      })
                      window.scrollTo({
                        left: 0,
                        top: 0
                      })
                    }}
                  >
                    <i className='outline envelope icon' />
                    <div className='content'>
                      <div>
                        <b>
                          {vote.formatedDate.toLocaleDateString(
                            `${locale}-CH`,
                            {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            }
                          )}
                        </b>
                      </div>
                      <div style={{ marginBottom: '.5em' }}>
                        {voteTitle === ''
                          ? messages.noNationalVoteTitle
                          : voteTitle}
                      </div>
                      <div>
                        <div className='ui button secondary'>
                          {format === 'main'
                            ? messages.allResults
                            : messages.findMunicipality}
                        </div>
                      </div>
                    </div>
                    {/* <div className='right floated content'>
                    <div className='ui button secondary'>
                      {format === 'main'
                        ? messages.allResults
                        : messages.findMunicipality}
                    </div>
                  </div> */}
                  </div>
                )
              })}
            </div>
          </div>
        ))}
      </div>
      <div style={{ textAlign: 'center' }}>
        {yearsMax < yearGroups.length && (
          <div
            className='ui button primary'
            onClick={() => {
              // Do the people actually use this menu?
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: `jump:showMore`
              })
              setYearsMax(yearsMax + 2)
            }}
          >
            {messages.showMore}
          </div>
        )}
      </div>
    </div>
  )
}
